import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f070af78&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f070af78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f070af78')) {
      api.createRecord('f070af78', component.options)
    } else {
      api.reload('f070af78', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f070af78&scoped=true&", function () {
      api.rerender('f070af78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HtPrint/index.vue"
export default component.exports